import { useTranslation } from "react-i18next";

const useGetEditFormValues = (profile, allowEmailEdit = false) => {
  const { t } = useTranslation();
  if (profile == null) {
    return new Array();
  }
  // Email is only editable while the account is inactive (not yet claimed by its owner)
  const emailField = {
    label: t("Email"),
    name: "email",
    defaultValue: profile?.email,
  };
  if (!profile?.businessAccount) {
    var userValues = [
      {
        label: t("Name"),
        name: "firstName",
        required: { required: t("EmptyField") },
        defaultValue: profile?.firstName,
      },
      {
        label: t("LastName"),
        name: "lastName",
        required: { required: t("EmptyField") },
        defaultValue: profile?.lastName,
      },
      {
        label: t("Username"),
        name: "username",
        required: { required: t("EmptyField") },
        defaultValue: profile?.username,
      },
      {
        label: t("PhoneNumber"),
        name: "phoneNumber",
        required: { required: t("EmptyField") },
        defaultValue: profile?.phoneNumber,
        maxLength: 15,
      },
      ...(allowEmailEdit ? [emailField] : []),
      {
        label: t("Oib"),
        name: "oib",
        defaultValue: profile?.oib,
      },
      {
        label: t("IdCardNumber"),
        name: "idCardNumber",
        defaultValue: profile?.idCardNumber,
      },
    ];
    return userValues;
  }
  const legalValues = [
    {
      label: t("Name"),
      name: "firstName",
      required: { required: t("EmptyField") },
      defaultValue: profile?.firstName,
    },
    {
      label: t("Username"),
      name: "username",
      required: { required: t("EmptyField") },
      defaultValue: profile?.username,
    },
    {
      label: t("Oib"),
      name: "oib",
      defaultValue: profile?.oib,
    },
    {
      label: t("PhoneNumber"),
      name: "phoneNumber",
      required: { required: t("EmptyField") },
      defaultValue: profile?.phoneNumber,
      maxLength: 15,
    },
    ...(allowEmailEdit ? [emailField] : []),
    {
      label: t("Persontocontact"),
      name: "personToContact",
      required: { required: t("EmptyField") },
      defaultValue: profile?.personToContact,
    },
  ];
  return legalValues;
};

export function useGetLocationFields(profile) {
  const { t } = useTranslation();
  if (profile == null) {
    return new Array();
  }
  return [
    {
      label: t("Address"),
      name: "address",
      defaultValue: profile?.location?.address,
    },
    {
      label: t("City"),
      name: "city",
      defaultValue: profile?.location?.city,
    },
    {
      label: t("Province"),
      name: "province",
      defaultValue: profile?.location?.province,
    },
    {
      label: t("Place"),
      name: "place",
      defaultValue: profile?.location?.place,
    },
    {
      label: t("Zipcode"),
      name: "zipcode",
      defaultValue: profile?.location?.zipcode,
    },
  ];
}
export { useGetEditFormValues };
